import React from "react";

// Donut with three arcs (protein/carbs/fat) sized by kcal share. Calories center.
export default function MacroDonut({ macros }) {
  const { calories, protein, carbs, fat } = macros;
  const pC = protein * 4, cC = carbs * 4, fC = fat * 9;
  const total = Math.max(pC + cC + fC, 1);
  const arcs = [
    { color: "var(--protein)", pct: pC / total, label: "P" },
    { color: "var(--carbs)", pct: cC / total, label: "C" },
    { color: "var(--fat)", pct: fC / total, label: "F" },
  ];
  const R = 70, C = 2 * Math.PI * R;
  let offset = 0;
  return (
    <div className="flex items-center gap-6" data-testid="macro-donut">
      <svg width="180" height="180" viewBox="0 0 180 180">
        <circle cx="90" cy="90" r={R} fill="none" stroke="#1A1A1A" strokeWidth="10" />
        {arcs.map((a, i) => {
          const len = a.pct * C;
          const el = (
            <circle key={i} cx="90" cy="90" r={R} fill="none" stroke={a.color} strokeWidth="10"
              strokeDasharray={`${len} ${C - len}`}
              strokeDashoffset={-offset}
              transform="rotate(-90 90 90)"
              strokeLinecap="butt"
            />
          );
          offset += len;
          return el;
        })}
        <text x="90" y="82" textAnchor="middle" fill="#fff" style={{ fontFamily: "Oswald", fontWeight: 700, fontSize: 34 }} className="tabular">{calories}</text>
        <text x="90" y="102" textAnchor="middle" fill="#525252" style={{ letterSpacing: 3 }} fontSize="9">KCAL</text>
      </svg>
      <div className="flex flex-col gap-2 text-sm">
        <Row color="var(--protein)" k="Protein" v={`${protein} g`} tid="donut-protein" />
        <Row color="var(--carbs)" k="Carbs" v={`${carbs} g`} tid="donut-carbs" />
        <Row color="var(--fat)" k="Fat" v={`${fat} g`} tid="donut-fat" />
      </div>
    </div>
  );
}
function Row({ color, k, v, tid }) {
  return (
    <div className="flex items-center gap-2" data-testid={tid}>
      <span className="w-2 h-2 rounded-full" style={{ background: color }} />
      <span className="text-t2 w-16">{k}</span>
      <span className="font-mono tabular">{v}</span>
    </div>
  );
}
